import { type FC, useEffect } from 'react';

import { useCurrentUserStore } from 'store/currentUser';
import { userAdapter } from 'store/users/helpers/userAdapter';

import Loader from 'components/UI/Loader';

import { provider } from 'providers';

import { useRedirectToAuth } from 'hooks/useRedirectToAuth';

import { useRecordLink } from './hooks/useRecordLink';
import { useRecordMetrics } from './hooks/useRecordMetrics';
import styles from './styles.module.scss';

const Record: FC = () => {
    const { setCurrentUser } = useCurrentUserStore();
    const recordLink = useRecordLink();
    const redirectToAuth = useRedirectToAuth();

    useEffect(() => {
        (async () => {
            try {
                const res = await provider.addUser();

                if ('_id' in res) {
                    setCurrentUser(userAdapter(res));
                } else {
                    throw new Error(JSON.stringify(res));
                }
            } catch (error) {
                redirectToAuth();
            }
        })();
    }, []);

    useRecordMetrics();

    if (!recordLink) return <Loader />;

    return (
        <div className={styles.wrapper}>
            <video className={styles.video} autoPlay muted controls src={recordLink}>
                <track kind='captions' />
            </video>
        </div>
    );
};

export default Record;
